import React, { ReactNode, JSX } from 'react';

export function RenderAppropriate<C extends React.ElementType>(
    DefaultComponent: C,
    props: React.ComponentPropsWithoutRef<C>,
    children?: ReactNode,
    AsComponent?: React.ElementType,
): JSX.Element {
    const Comp = (AsComponent || DefaultComponent) as React.ElementType;
    return <Comp {...(props as any)}>{children}</Comp>;
}
